import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/Banner/honarable-banner.webp";
import viceChancellor from "../../Images/Hon'ble Persons/Prof. (Dr.) Anand Mahalwar.webp"

const AboutUs = () => {
    return (
        <>
            <title>Pioneering Education | ISBM University | Vice Chancellor</title>
            <meta
                name="description"
                content="ISBM University's Honorable Vice Chancellor embodies visionary leadership. Explore his impactful message for shaping the future of education and learning."
            />

            <meta
                name="SearchEngines"
                content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
        DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
            />
            <meta name="Robots" content="INDEX, FOLLOW" />
            <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
            <meta name="Robots" content="INDEX,ALL" />
            <meta name="YahooSeeker" content="INDEX, FOLLOW" />
            <meta name="msnbot" content="INDEX, FOLLOW" />
            <meta name="googlebot" content="Default, follow" />
            <meta name="owner" content="isbmuniversity.edu.in/" />
            <meta name="language" content="English" />
            <meta name="revisit-after" content="2 days" />
            <meta
                property="og:title"
                content="Pioneering Education | ISBM University | Vice Chancellor "
            />
            <meta
                property="og:description"
                content="ISBM University's Honorable Vice Chancellor embodies visionary leadership. Explore his impactful message for shaping the future of education and learning."
            />
            <meta
                property="og:url"
                content="https://isbmuniversity.edu.in/honorable-vice-chancellor/"
            />
            <meta
                property="og:image"
                content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
            />
            <meta property="og:image:alt" content="ISBM University" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="ISBM University" />
            <meta
                name="twitter:title"
                content="Pioneering Education | ISBM University | Vice Chancellor "
            />
            <meta
                name="twitter:description"
                content="ISBM University's Honorable Vice Chancellor embodies visionary leadership. Explore his impactful message for shaping the future of education and learning."
            />
            <meta
                name="twitter:image:src"
                content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
            />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@ISBMUniversity" />
            <meta name="twitter:creator" content="@ISBMUniversity" />
            <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
            <meta property="twitter:account_id" content="758619542734053376" />
            <meta
                name="keywords"
                content="Vision for Education , Higher Education , Degree Programs"
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>From The Vice Chancellor's Desk</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Hon'ble Vice Chancellor
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="vc-section ptb-50">
                <div className="container-xxl">
                    <div className="vc-container">
                        <div className="vc-image-container">
                            <div className="vc-image-wrapper shadow-sm">
                                <img src={viceChancellor} alt="Prof. (Dr.) Anand Mahalwar" className="vc-image" />
                                <div className="vc-image-overlay"></div>
                            </div>
                            <div className="vc-title-box">
                                <span className="vc-designation">Hon'ble Vice Chancellor</span>
                                <h2 className="vc-name">Prof. (Dr.) Anand Mahalwar</h2>
                            </div>
                        </div>

                        <div className="vc-content">
                            <div className="vc-message">
                                <p className="vc-intro">
                                    It gives me great pleasure in extending my hearty welcome to all who are seeking admission to various Programmes of ISBM University.
                                </p>

                                <p>
                                    The University is a new-age University committed to provide innovative learning programmes to meet the current requirements of the society & industry. The programmes offered are research driven, skill based and knowledge intensive. The University is envisioned to be a centre of academic innovation and research where students and faculty will collaborate together to learn, research, create, innovate, inspire and incubate.
                                </p>

                                <div className="vc-highlight-box fw-semibold">
                                    <p>
                                        The ISBM University is established and approved by the Government of Chhattisgarh under the Chhattisgarh Private Universities (Establishment and Operation) Act, 2005 (Amendment Act 2016). It is recognized by the UGC and is an active member of the Association of Indian Universities (AIU).
                                    </p>
                                </div>

                                <p>
                                    The University endeavors to offer services across the student-life cycle, supporting students not only with teaching and learning, but also with career development, skill enhancement, employment opportunities, business incubation, fund raising, and mentoring.
                                </p>

                                <blockquote className="vc-quote">
                                    "What is really needed to make democracy function is not knowledge of facts, but right education."
                                    <cite>- Mahatma Gandhi</cite>
                                </blockquote>

                                <p className="p-0">
                                    The objective of the University is to provide higher education at the door steps of the aspirants. At ISBM, it is believed that imparting need-based, high-quality knowledge is the need of the hour in order to nurture young minds successfully to meet challenges of today's scenario, and to make them bloom as leaders to guide society.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default AboutUs;
